export default {
  startEndDateWarning: "End Date that is earlier than Start Date",
  campaignIdWarningHint: "Note: Campaign ID belongs to the exiting campaign.",
};
